import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import MapTypeButtons from './MapTypeButtons'
import AddEntityButton from './AddEntityButton'
import { CONTEXT_MENU_OPTIONS, DEFAULT_LABEL_DIMENSIONS, MOBILE_BREAKPOINT_WIDTH } from 'helpers/globals'
import { updateMapLocationAction, zoomToAllDevicesAction } from 'actions/mapActions'
import { addMarkupAction } from 'actions/markupActions'
import { updateCurrentEntityAction, checkOfflineLimitsAction } from 'actions/applicationActions'
import { addWireTooltipMapReferenceAction } from 'actions/entityActions'
import LabelOverlay from 'components/Markup/LabelOverlay'
import CamerasContainer from 'components/CamerasContainer'
import FloorPlansContainer from 'components/FloorPlansContainer'
import MarkupsContainer from 'components/MarkupsContainer'
import EntitiesContainer from 'components/EntitiesContainer'
import WireTooltipOverlay from 'components/Wire/TooltipOverlay'
import determineLocationOfNewLabel from 'helpers/map/determineLocationOfNewLabel'
import MediaQuery from 'react-responsive'
import { labelsSelector } from 'selectors/components'

const mapStateToProps = state => {
  const { exportType, exports, ui: { drawingWall, measurementTool, drawingWire, drawingMeasurement }, currentEntity: { type } } = state

  return {
    exportType,
    exporting: !EXPORT && !!exports.length,
    labels: labelsSelector(state),
    drawingWall,
    measurementTool,
    drawingWire,
    drawingMeasurement,
    currentEntityType: type
  }
}

class MapComponents extends React.Component {
  contextMenu = this.props.contextMenu

  eventHandler = (latLng, eventName) => {
    switch (eventName) {
      case 'addCamHere':
        this.props.checkOfflineLimitsAction('createCamera', [latLng])
        break
      case 'centerMapHere':
        const position = new google.maps.LatLng(latLng.lat(), latLng.lng())
        this.props.updateMapLocationAction(position)
        break
      case 'zoomToAllDevices':
        this.props.zoomToAllDevicesAction()
        break
    }
    return this.contextMenu.hide()
  }

  activateLabelInsertMode = _ => {
    const { map, labels, addMarkupAction } = this.props
    const location = determineLocationOfNewLabel({ map, labels })

    const overlay = new LabelOverlay({ dimensions: Object.assign({}, DEFAULT_LABEL_DIMENSIONS), location, enableEditMode: true, draggable: true })
    addMarkupAction('label', overlay)
  }

  componentDidUpdate = prevProps => {
    if (prevProps.exportType !== this.props.exportType) google.maps.event.trigger(this.props.map, 'resize')
  }

  componentWillReceiveProps = nextProps => {
    const { drawingManager, updateCurrentEntityAction } = nextProps

    if (['drawingWall', 'measurementTool', 'drawingWire'].some(key => nextProps[key] && nextProps[key] !== this.props[key]) && drawingManager.getDrawingMode()) {
      google.maps.event.addListenerOnce(drawingManager, 'overlaycomplete', e => updateCurrentEntityAction({ type: 'map' }))
      drawingManager.setDrawingMode(null)
    }
  }

  render() {
    const { activateLabelInsertMode, eventHandler, props: { map, drawingManager, drawingWall,
      drawingWire, drawingMeasurement, currentEntityType, addWireTooltipMapReferenceAction, classes } } = this
    const contextMenuOptions = CONTEXT_MENU_OPTIONS(classes)
    const drawing = drawingWall || drawingWire || drawingMeasurement

    return (
      <div>
        <MediaQuery minWidth={MOBILE_BREAKPOINT_WIDTH + 1}>
          <div className={classes.topMapButtonsContainer}>
            {!EXPORT && <AddEntityButton labelFn={activateLabelInsertMode} {...{ drawingManager, drawing, map, currentEntityType }} />}
          </div>
          <div className={classes.bottomMapButtonsContainer}>
            {!EXPORT && <MapTypeButtons drawing={drawing} />}
          </div>
        </MediaQuery>
        <CamerasContainer />
        <FloorPlansContainer map={map} contextMenuOptions={contextMenuOptions} mapContextMenuEventHandler={eventHandler} />
        <MarkupsContainer map={map} contextMenuOptions={contextMenuOptions} mapContextMenuEventHandler={eventHandler} />
        <EntitiesContainer />
        <WireTooltipOverlay map={map} addReference={addWireTooltipMapReferenceAction} />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateMapLocationAction, checkOfflineLimitsAction,
  zoomToAllDevicesAction, addMarkupAction, updateCurrentEntityAction, addWireTooltipMapReferenceAction })(injectSheet(style)(MapComponents))



// WEBPACK FOOTER //
// ./src/components/MapComponents/index.js